import { Controller } from "@hotwired/stimulus";
import Reveal from "stimulus-reveal-controller"

export default Reveal
